export const Settings: any = [
    {
        "id": 1,
        "name": "Graze",
        "description": null,
        "settings": [
            {
                "valueJson": "false",
                "optionsJson": "{\"options\":[]}",
                "key": "APPLY_GRATUITY_AFTER_DISCOUNT",
                "settingAreaId": 1,
                "name": "Apply Gratuity After Discount",
                "description": "Gratuity will be calculated on the entire amount prior to any discount.",
                "valueType": "Boolean",
                "audience": "General",
                "value": false,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:49.3433333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:25.6765469Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "false",
                "optionsJson": "{\"options\":[]}",
                "key": "APPLY_SERVICE_CHARGE_AFTER_DISCOUNT",
                "settingAreaId": 1,
                "name": "Apply Service Charge After Discount",
                "description": "Service Charge will be calculated on the entire amount prior to any discount.",
                "valueType": "Boolean",
                "audience": "General",
                "value": false,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:49.3433333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:25.6866303Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "true",
                "optionsJson": "{\"options\":[]}",
                "key": "APPLY_TAX_AFTER_DISCOUNT",
                "settingAreaId": 1,
                "name": "Apply Tax After Discount",
                "description": "Tax will be calculated on the entire amount prior to any discount.",
                "valueType": "Boolean",
                "audience": "General",
                "value": true,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:49.3433333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:25.7035966Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"USA35906\"",
                "optionsJson": "{\"options\":[]}",
                "key": "CATEREASE_SERIAL_NUMBER",
                "settingAreaId": 1,
                "name": "Caterease Serial Number",
                "description": "",
                "valueType": "String",
                "audience": "General",
                "value": "USA35906",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2022-05-18T02:20:00.81Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:25.7124808Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "true",
                "optionsJson": "{\"options\":[]}",
                "key": "ENABLE_CATEREASE_INTEGRATION",
                "settingAreaId": 1,
                "name": "Enable Caterease Integration",
                "description": "",
                "valueType": "Boolean",
                "audience": "Admin",
                "value": true,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2022-05-18T02:20:00.81Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:25.8919676Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "false",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_CHECKOUT_ASAP",
                "settingAreaId": 1,
                "name": "Disable ASAP",
                "description": "Disable the \"As Soon As Possible\" option for online orders.",
                "valueType": "Boolean",
                "audience": "General",
                "value": false,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-02-02T19:12:20.34Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.0585214Z",
                "createdBy": "DB Script",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "false",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_CHECKOUT_COUPON_CODE",
                "settingAreaId": 1,
                "name": "Disable Coupon Code at Checkout",
                "description": "",
                "valueType": "Boolean",
                "audience": "General",
                "value": false,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2023-07-26T13:41:50.66Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.0674409Z",
                "createdBy": "DB Script",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "false",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_CHECKOUT_ENABLE_OPERATION",
                "settingAreaId": 1,
                "name": "Enable Location",
                "description": "Show \"Location\" option for online orders at checkout.",
                "valueType": "Boolean",
                "audience": "General",
                "value": false,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2023-04-05T15:21:43.6833333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.0750655Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "false",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_CHECKOUT_PAY_LATER",
                "settingAreaId": 1,
                "name": "Disable Pay Later",
                "description": "Online orders will only be submitted with payment; the \"Pay Later\" option will be disabled.",
                "valueType": "Boolean",
                "audience": "General",
                "value": false,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-02-02T19:12:20.34Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.0830711Z",
                "createdBy": "DB Script",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "false",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_CHECKOUT_PAY_NOW",
                "settingAreaId": 1,
                "name": "Disable Pay Now",
                "description": "Online orders will only be submitted without payment; the \"Pay Now\" option will be disabled.",
                "valueType": "Boolean",
                "audience": "General",
                "value": false,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2022-08-18T13:26:51.2766667Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.0907474Z",
                "createdBy": "DB Script",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"https://horizoncoverstagingsa.blob.core.windows.net/public/2a73da9d-3163-4eeb-cda8-08d77746ce6e/companyLogo/-1/11f22b40-2dfe-457f-96be-d6ae8dd7b3dc.png\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_COMPANY_LOGO",
                "settingAreaId": 1,
                "name": "Company Logo",
                "description": "Upload a logo to be displayed at the top left of your online ordering screen. (Transparent background recommended.)",
                "valueType": "Custom",
                "audience": "General",
                "value": "https://horizoncoverstagingsa.blob.core.windows.net/public/2a73da9d-3163-4eeb-cda8-08d77746ce6e/companyLogo/-1/11f22b40-2dfe-457f-96be-d6ae8dd7b3dc.png",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:47.25Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.0994319Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"chris@caterease.com\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_CONTACT_EMAIL_ADDRESSES",
                "settingAreaId": 1,
                "name": "Contact Form Email To",
                "description": "The Contact form under the end user's profile will be sent to this email address.",
                "valueType": "String",
                "audience": "General",
                "value": "chris@caterease.com",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:48.85Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1084207Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "false",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ENABLE_PRODUCT_ALLERGENS",
                "settingAreaId": 1,
                "name": "Disable Product Allergy Information",
                "description": "",
                "valueType": "Boolean",
                "audience": "General",
                "value": false,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2023-02-20T16:06:43.31Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1163464Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "false",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ENABLE_SPECIAL_INSTRUCTIONS",
                "settingAreaId": 1,
                "name": "Disable Product Special Instructions",
                "description": "",
                "valueType": "Boolean",
                "audience": "General",
                "value": false,
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2023-07-25T19:42:25.7066667Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1246545Z",
                "createdBy": "DB Script",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"Poppins\"",
                "optionsJson": "{\"options\":[\"Yanone Kaffeesatz\",\"ABeeZee\",\"Abel\",\"Abhaya Libre\",\"Abril Fatface\",\"Aclonica\",\"Acme\",\"Actor\",\"Adamina\",\"Advent Pro\",\"Aguafina Script\",\"Akaya Kanadaka\",\"Akaya Telivigala\",\"Akronim\",\"Aladin\",\"Alata\",\"Alatsi\",\"Aldrich\",\"Alef\",\"Alegreya\",\"Alegreya SC\",\"Alegreya Sans\",\"Alegreya Sans SC\",\"Aleo\",\"Alex Brush\",\"Alfa Slab One\",\"Alice\",\"Alike\",\"Alike Angular\",\"Allan\",\"Allerta\",\"Allerta Stencil\",\"Allura\",\"Almarai\",\"Almendra\",\"Almendra Display\",\"Almendra SC\",\"Amarante\",\"Amaranth\",\"Amatic SC\",\"Amethysta\",\"Amiko\",\"Amiri\",\"Amita\",\"Anaheim\",\"Andada\",\"Andika\",\"Andika New Basic\",\"Angkor\",\"Annie Use Your Telescope\",\"Anonymous Pro\",\"Antic\",\"Antic Didone\",\"Antic Slab\",\"Anton\",\"Antonio\",\"Arapey\",\"Arbutus\",\"Arbutus Slab\",\"Architects Daughter\",\"Archivo\",\"Archivo Black\",\"Archivo Narrow\",\"Aref Ruqaa\",\"Arima Madurai\",\"Arimo\",\"Arizonia\",\"Armata\",\"Arsenal\",\"Artifika\",\"Arvo\",\"Arya\",\"Asap\",\"Asap Condensed\",\"Asar\",\"Asset\",\"Assistant\",\"Astloch\",\"Asul\",\"Athiti\",\"Atma\",\"Atomic Age\",\"Aubrey\",\"Audiowide\",\"Autour One\",\"Average\",\"Average Sans\",\"Averia Gruesa Libre\",\"Averia Libre\",\"Averia Sans Libre\",\"Averia Serif Libre\",\"B612\",\"B612 Mono\",\"Bad Script\",\"Bahiana\",\"Bahianita\",\"Bai Jamjuree\",\"Ballet\",\"Baloo 2\",\"Baloo Bhai 2\",\"Baloo Bhaina 2\",\"Baloo Chettan 2\",\"Baloo Da 2\",\"Baloo Paaji 2\",\"Baloo Tamma 2\",\"Baloo Tammudu 2\",\"Baloo Thambi 2\",\"Balsamiq Sans\",\"Balthazar\",\"Bangers\",\"Barlow\",\"Barlow Condensed\",\"Barlow Semi Condensed\",\"Barriecito\",\"Barrio\",\"Basic\",\"Baskervville\",\"Battambang\",\"Baumans\",\"Bayon\",\"Be Vietnam\",\"Bebas Neue\",\"Belgrano\",\"Bellefair\",\"Belleza\",\"Bellota\",\"Bellota Text\",\"BenchNine\",\"Benne\",\"Bentham\",\"Berkshire Swash\",\"Beth Ellen\",\"Bevan\",\"Big Shoulders Display\",\"Big Shoulders Inline Display\",\"Big Shoulders Inline Text\",\"Big Shoulders Stencil Display\",\"Big Shoulders Stencil Text\",\"Big Shoulders Text\",\"Bigelow Rules\",\"Bigshot One\",\"Bilbo\",\"Bilbo Swash Caps\",\"BioRhyme\",\"BioRhyme Expanded\",\"Biryani\",\"Bitter\",\"Black And White Picture\",\"Black Han Sans\",\"Black Ops One\",\"Blinker\",\"Bodoni Moda\",\"Bokor\",\"Bonbon\",\"Boogaloo\",\"Bowlby One\",\"Bowlby One SC\",\"Brawler\",\"Bree Serif\",\"Brygada 1918\",\"Bubblegum Sans\",\"Bubbler One\",\"Buda\",\"Buenard\",\"Bungee\",\"Bungee Hairline\",\"Bungee Inline\",\"Bungee Outline\",\"Bungee Shade\",\"Butcherman\",\"Butterfly Kids\",\"Cabin\",\"Cabin Condensed\",\"Cabin Sketch\",\"Caesar Dressing\",\"Cagliostro\",\"Cairo\",\"Caladea\",\"Calistoga\",\"Calligraffitti\",\"Cambay\",\"Cambo\",\"Candal\",\"Cantarell\",\"Cantata One\",\"Cantora One\",\"Capriola\",\"Cardo\",\"Carme\",\"Carrois Gothic\",\"Carrois Gothic SC\",\"Carter One\",\"Castoro\",\"Catamaran\",\"Caudex\",\"Caveat\",\"Caveat Brush\",\"Cedarville Cursive\",\"Ceviche One\",\"Chakra Petch\",\"Changa\",\"Changa One\",\"Chango\",\"Charm\",\"Charmonman\",\"Chathura\",\"Chau Philomene One\",\"Chela One\",\"Chelsea Market\",\"Chenla\",\"Cherry Cream Soda\",\"Cherry Swash\",\"Chewy\",\"Chicle\",\"Chilanka\",\"Chivo\",\"Chonburi\",\"Cinzel\",\"Cinzel Decorative\",\"Clicker Script\",\"Coda\",\"Coda Caption\",\"Codystar\",\"Coiny\",\"Combo\",\"Comfortaa\",\"Comic Neue\",\"Coming Soon\",\"Commissioner\",\"Concert One\",\"Condiment\",\"Content\",\"Contrail One\",\"Convergence\",\"Cookie\",\"Copse\",\"Corben\",\"Cormorant\",\"Cormorant Garamond\",\"Cormorant Infant\",\"Cormorant SC\",\"Cormorant Unicase\",\"Cormorant Upright\",\"Courgette\",\"Courier Prime\",\"Cousine\",\"Coustard\",\"Covered By Your Grace\",\"Crafty Girls\",\"Creepster\",\"Crete Round\",\"Crimson Pro\",\"Crimson Text\",\"Croissant One\",\"Crushed\",\"Cuprum\",\"Cute Font\",\"Cutive\",\"Cutive Mono\",\"DM Mono\",\"DM Sans\",\"DM Serif Display\",\"DM Serif Text\",\"Damion\",\"Dancing Script\",\"Dangrek\",\"Darker Grotesque\",\"David Libre\",\"Dawning of a New Day\",\"Days One\",\"Dekko\",\"Dela Gothic One\",\"Delius\",\"Delius Swash Caps\",\"Delius Unicase\",\"Della Respira\",\"Denk One\",\"Devonshire\",\"Dhurjati\",\"Didact Gothic\",\"Diplomata\",\"Diplomata SC\",\"Do Hyeon\",\"Dokdo\",\"Domine\",\"Donegal One\",\"Doppio One\",\"Dorsa\",\"Dosis\",\"DotGothic16\",\"Dr Sugiyama\",\"Duru Sans\",\"Dynalight\",\"EB Garamond\",\"Eagle Lake\",\"East Sea Dokdo\",\"Eater\",\"Economica\",\"Eczar\",\"El Messiri\",\"Electrolize\",\"Elsie\",\"Elsie Swash Caps\",\"Emblema One\",\"Emilys Candy\",\"Encode Sans\",\"Encode Sans Condensed\",\"Encode Sans Expanded\",\"Encode Sans Semi Condensed\",\"Encode Sans Semi Expanded\",\"Engagement\",\"Englebert\",\"Enriqueta\",\"Epilogue\",\"Erica One\",\"Esteban\",\"Euphoria Script\",\"Ewert\",\"Exo\",\"Exo 2\",\"Expletus Sans\",\"Fahkwang\",\"Fanwood Text\",\"Farro\",\"Farsan\",\"Fascinate\",\"Fascinate Inline\",\"Faster One\",\"Fasthand\",\"Fauna One\",\"Faustina\",\"Federant\",\"Federo\",\"Felipa\",\"Fenix\",\"Finger Paint\",\"Fira Code\",\"Fira Mono\",\"Fira Sans\",\"Fira Sans Condensed\",\"Fira Sans Extra Condensed\",\"Fjalla One\",\"Fjord One\",\"Flamenco\",\"Flavors\",\"Fondamento\",\"Fontdiner Swanky\",\"Forum\",\"Francois One\",\"Frank Ruhl Libre\",\"Fraunces\",\"Freckle Face\",\"Fredericka the Great\",\"Fredoka One\",\"Freehand\",\"Fresca\",\"Frijole\",\"Fruktur\",\"Fugaz One\",\"GFS Didot\",\"GFS Neohellenic\",\"Gabriela\",\"Gaegu\",\"Gafata\",\"Galada\",\"Galdeano\",\"Galindo\",\"Gamja Flower\",\"Gayathri\",\"Gelasio\",\"Gentium Basic\",\"Gentium Book Basic\",\"Geo\",\"Geostar\",\"Geostar Fill\",\"Germania One\",\"Gidugu\",\"Gilda Display\",\"Girassol\",\"Give You Glory\",\"Glass Antiqua\",\"Glegoo\",\"Gloria Hallelujah\",\"Goblin One\",\"Gochi Hand\",\"Goldman\",\"Gorditas\",\"Gothic A1\",\"Gotu\",\"Goudy Bookletter 1911\",\"Graduate\",\"Grand Hotel\",\"Grandstander\",\"Gravitas One\",\"Great Vibes\",\"Grenze\",\"Grenze Gotisch\",\"Griffy\",\"Gruppo\",\"Gudea\",\"Gugi\",\"Gupter\",\"Gurajada\",\"Habibi\",\"Hachi Maru Pop\",\"Halant\",\"Hammersmith One\",\"Hanalei\",\"Hanalei Fill\",\"Handlee\",\"Hanuman\",\"Happy Monkey\",\"Harmattan\",\"Headland One\",\"Heebo\",\"Henny Penny\",\"Hepta Slab\",\"Herr Von Muellerhoff\",\"Hi Melody\",\"Hind\",\"Hind Guntur\",\"Hind Madurai\",\"Hind Siliguri\",\"Hind Vadodara\",\"Holtwood One SC\",\"Homemade Apple\",\"Homenaje\",\"IBM Plex Mono\",\"IBM Plex Sans\",\"IBM Plex Sans Condensed\",\"IBM Plex Serif\",\"IM Fell DW Pica\",\"IM Fell DW Pica SC\",\"IM Fell Double Pica\",\"IM Fell Double Pica SC\",\"IM Fell English\",\"IM Fell English SC\",\"IM Fell French Canon\",\"IM Fell French Canon SC\",\"IM Fell Great Primer\",\"IM Fell Great Primer SC\",\"Ibarra Real Nova\",\"Iceberg\",\"Iceland\",\"Imbue\",\"Imprima\",\"Inconsolata\",\"Inder\",\"Indie Flower\",\"Inika\",\"Inknut Antiqua\",\"Inria Sans\",\"Inria Serif\",\"Inter\",\"Irish Grover\",\"Istok Web\",\"Italiana\",\"Italianno\",\"Itim\",\"Jacques Francois\",\"Jacques Francois Shadow\",\"Jaldi\",\"JetBrains Mono\",\"Jim Nightshade\",\"Jockey One\",\"Jolly Lodger\",\"Jomhuria\",\"Jomolhari\",\"Josefin Sans\",\"Josefin Slab\",\"Jost\",\"Joti One\",\"Jua\",\"Judson\",\"Julee\",\"Julius Sans One\",\"Junge\",\"Jura\",\"Just Another Hand\",\"Just Me Again Down Here\",\"K2D\",\"Kadwa\",\"Kalam\",\"Kameron\",\"Kanit\",\"Kantumruy\",\"Karantina\",\"Karla\",\"Karma\",\"Katibeh\",\"Kaushan Script\",\"Kavivanar\",\"Kavoon\",\"Kdam Thmor\",\"Keania One\",\"Kelly Slab\",\"Kenia\",\"Khand\",\"Khmer\",\"Khula\",\"Kirang Haerang\",\"Kite One\",\"Kiwi Maru\",\"Knewave\",\"KoHo\",\"Kodchasan\",\"Kosugi\",\"Kosugi Maru\",\"Kotta One\",\"Koulen\",\"Kranky\",\"Kreon\",\"Kristi\",\"Krona One\",\"Krub\",\"Kufam\",\"Kulim Park\",\"Kumar One\",\"Kumar One Outline\",\"Kumbh Sans\",\"Kurale\",\"La Belle Aurore\",\"Lacquer\",\"Laila\",\"Lakki Reddy\",\"Lalezar\",\"Lancelot\",\"Langar\",\"Lateef\",\"Lato\",\"League Script\",\"Leckerli One\",\"Ledger\",\"Lekton\",\"Lemon\",\"Lemonada\",\"Lexend\",\"Lexend Deca\",\"Lexend Exa\",\"Lexend Giga\",\"Lexend Mega\",\"Lexend Peta\",\"Lexend Tera\",\"Lexend Zetta\",\"Libre Barcode 128\",\"Libre Barcode 128 Text\",\"Libre Barcode 39\",\"Libre Barcode 39 Extended\",\"Libre Barcode 39 Extended Text\",\"Libre Barcode 39 Text\",\"Libre Barcode EAN13 Text\",\"Libre Baskerville\",\"Libre Caslon Display\",\"Libre Caslon Text\",\"Libre Franklin\",\"Life Savers\",\"Lilita One\",\"Lily Script One\",\"Limelight\",\"Linden Hill\",\"Literata\",\"Liu Jian Mao Cao\",\"Livvic\",\"Lobster\",\"Lobster Two\",\"Londrina Outline\",\"Londrina Shadow\",\"Londrina Sketch\",\"Londrina Solid\",\"Long Cang\",\"Lora\",\"Love Ya Like A Sister\",\"Loved by the King\",\"Lovers Quarrel\",\"Luckiest Guy\",\"Lusitana\",\"Lustria\",\"M PLUS 1p\",\"M PLUS Rounded 1c\",\"Ma Shan Zheng\",\"Macondo\",\"Macondo Swash Caps\",\"Mada\",\"Magra\",\"Maiden Orange\",\"Maitree\",\"Major Mono Display\",\"Mako\",\"Mali\",\"Mallanna\",\"Mandali\",\"Manjari\",\"Manrope\",\"Mansalva\",\"Manuale\",\"Marcellus\",\"Marcellus SC\",\"Marck Script\",\"Margarine\",\"Markazi Text\",\"Marko One\",\"Marmelad\",\"Martel\",\"Martel Sans\",\"Marvel\",\"Mate\",\"Mate SC\",\"Maven Pro\",\"McLaren\",\"Meddon\",\"MedievalSharp\",\"Medula One\",\"Meera Inimai\",\"Megrim\",\"Meie Script\",\"Merienda\",\"Merienda One\",\"Merriweather\",\"Merriweather Sans\",\"Metal\",\"Metal Mania\",\"Metamorphous\",\"Metrophobic\",\"Michroma\",\"Milonga\",\"Miltonian\",\"Miltonian Tattoo\",\"Mina\",\"Miniver\",\"Miriam Libre\",\"Mirza\",\"Miss Fajardose\",\"Mitr\",\"Modak\",\"Modern Antiqua\",\"Mogra\",\"Molengo\",\"Molle\",\"Monda\",\"Monofett\",\"Monoton\",\"Monsieur La Doulaise\",\"Montaga\",\"Montez\",\"Montserrat\",\"Montserrat Alternates\",\"Montserrat Subrayada\",\"Moul\",\"Moulpali\",\"Mountains of Christmas\",\"Mouse Memoirs\",\"Mr Bedfort\",\"Mr Dafoe\",\"Mr De Haviland\",\"Mrs Saint Delafield\",\"Mrs Sheppards\",\"Mukta\",\"Mukta Mahee\",\"Mukta Malar\",\"Mukta Vaani\",\"Mulish\",\"MuseoModerno\",\"Mystery Quest\",\"NTR\",\"Nanum Brush Script\",\"Nanum Gothic\",\"Nanum Gothic Coding\",\"Nanum Myeongjo\",\"Nanum Pen Script\",\"Nerko One\",\"Neucha\",\"Neuton\",\"New Rocker\",\"New Tegomin\",\"News Cycle\",\"Newsreader\",\"Niconne\",\"Niramit\",\"Nixie One\",\"Nobile\",\"Nokora\",\"Norican\",\"Nosifer\",\"Notable\",\"Nothing You Could Do\",\"Noticia Text\",\"Noto Sans\",\"Noto Sans HK\",\"Noto Sans JP\",\"Noto Sans KR\",\"Noto Sans SC\",\"Noto Sans TC\",\"Noto Serif\",\"Noto Serif JP\",\"Noto Serif KR\",\"Noto Serif SC\",\"Noto Serif TC\",\"Nova Cut\",\"Nova Flat\",\"Nova Mono\",\"Nova Oval\",\"Nova Round\",\"Nova Script\",\"Nova Slim\",\"Nova Square\",\"Numans\",\"Nunito\",\"Nunito Sans\",\"Odibee Sans\",\"Odor Mean Chey\",\"Offside\",\"Oi\",\"Old Standard TT\",\"Oldenburg\",\"Oleo Script\",\"Oleo Script Swash Caps\",\"Open Sans\",\"Open Sans Condensed\",\"Oranienbaum\",\"Orbitron\",\"Oregano\",\"Orelega One\",\"Orienta\",\"Original Surfer\",\"Oswald\",\"Over the Rainbow\",\"Overlock\",\"Overlock SC\",\"Overpass\",\"Overpass Mono\",\"Ovo\",\"Oxanium\",\"Oxygen\",\"Oxygen Mono\",\"PT Mono\",\"PT Sans\",\"PT Sans Caption\",\"PT Sans Narrow\",\"PT Serif\",\"PT Serif Caption\",\"Pacifico\",\"Padauk\",\"Palanquin\",\"Palanquin Dark\",\"Pangolin\",\"Paprika\",\"Parisienne\",\"Passero One\",\"Passion One\",\"Pathway Gothic One\",\"Patrick Hand\",\"Patrick Hand SC\",\"Pattaya\",\"Patua One\",\"Pavanam\",\"Paytone One\",\"Peddana\",\"Peralta\",\"Permanent Marker\",\"Petit Formal Script\",\"Petrona\",\"Philosopher\",\"Piazzolla\",\"Piedra\",\"Pinyon Script\",\"Pirata One\",\"Plaster\",\"Play\",\"Playball\",\"Playfair Display\",\"Playfair Display SC\",\"Podkova\",\"Poiret One\",\"Poller One\",\"Poly\",\"Pompiere\",\"Pontano Sans\",\"Poor Story\",\"Poppins\",\"Port Lligat Sans\",\"Port Lligat Slab\",\"Potta One\",\"Pragati Narrow\",\"Prata\",\"Preahvihear\",\"Press Start 2P\",\"Pridi\",\"Princess Sofia\",\"Prociono\",\"Prompt\",\"Prosto One\",\"Proza Libre\",\"Public Sans\",\"Puritan\",\"Purple Purse\",\"Quando\",\"Quantico\",\"Quattrocento\",\"Quattrocento Sans\",\"Questrial\",\"Quicksand\",\"Quintessential\",\"Qwigley\",\"Racing Sans One\",\"Radley\",\"Rajdhani\",\"Rakkas\",\"Raleway\",\"Raleway Dots\",\"Ramabhadra\",\"Ramaraja\",\"Rambla\",\"Rammetto One\",\"Ranchers\",\"Rancho\",\"Ranga\",\"Rasa\",\"Rationale\",\"Ravi Prakash\",\"Recursive\",\"Red Hat Display\",\"Red Hat Text\",\"Red Rose\",\"Redressed\",\"Reem Kufi\",\"Reenie Beanie\",\"Reggae One\",\"Revalia\",\"Rhodium Libre\",\"Ribeye\",\"Ribeye Marrow\",\"Righteous\",\"Risque\",\"Roboto\",\"Roboto Condensed\",\"Roboto Mono\",\"Roboto Slab\",\"Rochester\",\"Rock Salt\",\"RocknRoll One\",\"Rokkitt\",\"Romanesco\",\"Ropa Sans\",\"Rosario\",\"Rosarivo\",\"Rouge Script\",\"Rowdies\",\"Rozha One\",\"Rubik\",\"Rubik Mono One\",\"Ruda\",\"Rufina\",\"Ruge Boogie\",\"Ruluko\",\"Rum Raisin\",\"Ruslan Display\",\"Russo One\",\"Ruthie\",\"Rye\",\"Sacramento\",\"Sahitya\",\"Sail\",\"Saira\",\"Saira Condensed\",\"Saira Extra Condensed\",\"Saira Semi Condensed\",\"Saira Stencil One\",\"Salsa\",\"Sanchez\",\"Sancreek\",\"Sansita\",\"Sansita Swashed\",\"Sarabun\",\"Sarala\",\"Sarina\",\"Sarpanch\",\"Satisfy\",\"Sawarabi Gothic\",\"Sawarabi Mincho\",\"Scada\",\"Scheherazade\",\"Schoolbell\",\"Scope One\",\"Seaweed Script\",\"Secular One\",\"Sedgwick Ave\",\"Sedgwick Ave Display\",\"Sen\",\"Sevillana\",\"Seymour One\",\"Shadows Into Light\",\"Shadows Into Light Two\",\"Shanti\",\"Share\",\"Share Tech\",\"Share Tech Mono\",\"Shippori Mincho\",\"Shippori Mincho B1\",\"Shojumaru\",\"Short Stack\",\"Shrikhand\",\"Siemreap\",\"Sigmar One\",\"Signika\",\"Signika Negative\",\"Simonetta\",\"Single Day\",\"Sintony\",\"Sirin Stencil\",\"Six Caps\",\"Skranji\",\"Slabo 13px\",\"Slabo 27px\",\"Slackey\",\"Smokum\",\"Smythe\",\"Sniglet\",\"Snippet\",\"Snowburst One\",\"Sofadi One\",\"Sofia\",\"Solway\",\"Song Myung\",\"Sonsie One\",\"Sora\",\"Sorts Mill Goudy\",\"Source Code Pro\",\"Source Sans Pro\",\"Source Serif Pro\",\"Space Grotesk\",\"Space Mono\",\"Spartan\",\"Special Elite\",\"Spectral\",\"Spectral SC\",\"Spicy Rice\",\"Spinnaker\",\"Spirax\",\"Squada One\",\"Sree Krushnadevaraya\",\"Sriracha\",\"Srisakdi\",\"Staatliches\",\"Stalemate\",\"Stalinist One\",\"Stardos Stencil\",\"Stick\",\"Stint Ultra Condensed\",\"Stint Ultra Expanded\",\"Stoke\",\"Strait\",\"Stylish\",\"Sue Ellen Francisco\",\"Suez One\",\"Sulphur Point\",\"Sumana\",\"Sunflower\",\"Sunshiney\",\"Supermercado One\",\"Sura\",\"Suranna\",\"Suravaram\",\"Suwannaphum\",\"Swanky and Moo Moo\",\"Syncopate\",\"Syne\",\"Syne Mono\",\"Syne Tactile\",\"Tajawal\",\"Tangerine\",\"Taprom\",\"Tauri\",\"Taviraj\",\"Teko\",\"Telex\",\"Tenali Ramakrishna\",\"Tenor Sans\",\"Text Me One\",\"Texturina\",\"Thasadith\",\"The Girl Next Door\",\"Tienne\",\"Tillana\",\"Timmana\",\"Tinos\",\"Titan One\",\"Titillium Web\",\"Tomorrow\",\"Trade Winds\",\"Train One\",\"Trirong\",\"Trispace\",\"Trocchi\",\"Trochut\",\"Truculenta\",\"Trykker\",\"Tulpen One\",\"Turret Road\",\"Ubuntu\",\"Ubuntu Condensed\",\"Ubuntu Mono\",\"Ultra\",\"Uncial Antiqua\",\"Underdog\",\"Unica One\",\"UnifrakturCook\",\"UnifrakturMaguntia\",\"Unkempt\",\"Unlock\",\"Unna\",\"VT323\",\"Vampiro One\",\"Varela\",\"Varela Round\",\"Varta\",\"Vast Shadow\",\"Vesper Libre\",\"Viaoda Libre\",\"Vibes\",\"Vibur\",\"Vidaloka\",\"Viga\",\"Voces\",\"Volkhov\",\"Vollkorn\",\"Vollkorn SC\",\"Voltaire\",\"Waiting for the Sunrise\",\"Wallpoet\",\"Walter Turncoat\",\"Warnes\",\"Wellfleet\",\"Wendy One\",\"Wire One\",\"Work Sans\",\"Xanh Mono\",\"Yantramanav\",\"Yatra One\",\"Yellowtail\",\"Yeon Sung\",\"Yeseva One\",\"Yesteryear\",\"Yrsa\",\"Yusei Magic\",\"ZCOOL KuaiLe\",\"ZCOOL QingKe HuangYou\",\"ZCOOL XiaoWei\",\"Zen Dots\",\"Zeyada\",\"Zhi Mang Xing\",\"Zilla Slab\",\"Zilla Slab Highlight\"]}",
                "key": "GRAZE_FONT",
                "settingAreaId": 1,
                "name": "Online System Font",
                "description": "Text on the online ordering page will be displayed in this font.",
                "valueType": "Dropdown",
                "audience": "General",
                "value": "Poppins",
                "options": [
                    "Yanone Kaffeesatz",
                    "ABeeZee",
                    "Abel",
                    "Abhaya Libre",
                    "Abril Fatface",
                    "Aclonica",
                    "Acme",
                    "Actor",
                    "Adamina",
                    "Advent Pro",
                    "Aguafina Script",
                    "Akaya Kanadaka",
                    "Akaya Telivigala",
                    "Akronim",
                    "Aladin",
                    "Alata",
                    "Alatsi",
                    "Aldrich",
                    "Alef",
                    "Alegreya",
                    "Alegreya SC",
                    "Alegreya Sans",
                    "Alegreya Sans SC",
                    "Aleo",
                    "Alex Brush",
                    "Alfa Slab One",
                    "Alice",
                    "Alike",
                    "Alike Angular",
                    "Allan",
                    "Allerta",
                    "Allerta Stencil",
                    "Allura",
                    "Almarai",
                    "Almendra",
                    "Almendra Display",
                    "Almendra SC",
                    "Amarante",
                    "Amaranth",
                    "Amatic SC",
                    "Amethysta",
                    "Amiko",
                    "Amiri",
                    "Amita",
                    "Anaheim",
                    "Andada",
                    "Andika",
                    "Andika New Basic",
                    "Angkor",
                    "Annie Use Your Telescope",
                    "Anonymous Pro",
                    "Antic",
                    "Antic Didone",
                    "Antic Slab",
                    "Anton",
                    "Antonio",
                    "Arapey",
                    "Arbutus",
                    "Arbutus Slab",
                    "Architects Daughter",
                    "Archivo",
                    "Archivo Black",
                    "Archivo Narrow",
                    "Aref Ruqaa",
                    "Arima Madurai",
                    "Arimo",
                    "Arizonia",
                    "Armata",
                    "Arsenal",
                    "Artifika",
                    "Arvo",
                    "Arya",
                    "Asap",
                    "Asap Condensed",
                    "Asar",
                    "Asset",
                    "Assistant",
                    "Astloch",
                    "Asul",
                    "Athiti",
                    "Atma",
                    "Atomic Age",
                    "Aubrey",
                    "Audiowide",
                    "Autour One",
                    "Average",
                    "Average Sans",
                    "Averia Gruesa Libre",
                    "Averia Libre",
                    "Averia Sans Libre",
                    "Averia Serif Libre",
                    "B612",
                    "B612 Mono",
                    "Bad Script",
                    "Bahiana",
                    "Bahianita",
                    "Bai Jamjuree",
                    "Ballet",
                    "Baloo 2",
                    "Baloo Bhai 2",
                    "Baloo Bhaina 2",
                    "Baloo Chettan 2",
                    "Baloo Da 2",
                    "Baloo Paaji 2",
                    "Baloo Tamma 2",
                    "Baloo Tammudu 2",
                    "Baloo Thambi 2",
                    "Balsamiq Sans",
                    "Balthazar",
                    "Bangers",
                    "Barlow",
                    "Barlow Condensed",
                    "Barlow Semi Condensed",
                    "Barriecito",
                    "Barrio",
                    "Basic",
                    "Baskervville",
                    "Battambang",
                    "Baumans",
                    "Bayon",
                    "Be Vietnam",
                    "Bebas Neue",
                    "Belgrano",
                    "Bellefair",
                    "Belleza",
                    "Bellota",
                    "Bellota Text",
                    "BenchNine",
                    "Benne",
                    "Bentham",
                    "Berkshire Swash",
                    "Beth Ellen",
                    "Bevan",
                    "Big Shoulders Display",
                    "Big Shoulders Inline Display",
                    "Big Shoulders Inline Text",
                    "Big Shoulders Stencil Display",
                    "Big Shoulders Stencil Text",
                    "Big Shoulders Text",
                    "Bigelow Rules",
                    "Bigshot One",
                    "Bilbo",
                    "Bilbo Swash Caps",
                    "BioRhyme",
                    "BioRhyme Expanded",
                    "Biryani",
                    "Bitter",
                    "Black And White Picture",
                    "Black Han Sans",
                    "Black Ops One",
                    "Blinker",
                    "Bodoni Moda",
                    "Bokor",
                    "Bonbon",
                    "Boogaloo",
                    "Bowlby One",
                    "Bowlby One SC",
                    "Brawler",
                    "Bree Serif",
                    "Brygada 1918",
                    "Bubblegum Sans",
                    "Bubbler One",
                    "Buda",
                    "Buenard",
                    "Bungee",
                    "Bungee Hairline",
                    "Bungee Inline",
                    "Bungee Outline",
                    "Bungee Shade",
                    "Butcherman",
                    "Butterfly Kids",
                    "Cabin",
                    "Cabin Condensed",
                    "Cabin Sketch",
                    "Caesar Dressing",
                    "Cagliostro",
                    "Cairo",
                    "Caladea",
                    "Calistoga",
                    "Calligraffitti",
                    "Cambay",
                    "Cambo",
                    "Candal",
                    "Cantarell",
                    "Cantata One",
                    "Cantora One",
                    "Capriola",
                    "Cardo",
                    "Carme",
                    "Carrois Gothic",
                    "Carrois Gothic SC",
                    "Carter One",
                    "Castoro",
                    "Catamaran",
                    "Caudex",
                    "Caveat",
                    "Caveat Brush",
                    "Cedarville Cursive",
                    "Ceviche One",
                    "Chakra Petch",
                    "Changa",
                    "Changa One",
                    "Chango",
                    "Charm",
                    "Charmonman",
                    "Chathura",
                    "Chau Philomene One",
                    "Chela One",
                    "Chelsea Market",
                    "Chenla",
                    "Cherry Cream Soda",
                    "Cherry Swash",
                    "Chewy",
                    "Chicle",
                    "Chilanka",
                    "Chivo",
                    "Chonburi",
                    "Cinzel",
                    "Cinzel Decorative",
                    "Clicker Script",
                    "Coda",
                    "Coda Caption",
                    "Codystar",
                    "Coiny",
                    "Combo",
                    "Comfortaa",
                    "Comic Neue",
                    "Coming Soon",
                    "Commissioner",
                    "Concert One",
                    "Condiment",
                    "Content",
                    "Contrail One",
                    "Convergence",
                    "Cookie",
                    "Copse",
                    "Corben",
                    "Cormorant",
                    "Cormorant Garamond",
                    "Cormorant Infant",
                    "Cormorant SC",
                    "Cormorant Unicase",
                    "Cormorant Upright",
                    "Courgette",
                    "Courier Prime",
                    "Cousine",
                    "Coustard",
                    "Covered By Your Grace",
                    "Crafty Girls",
                    "Creepster",
                    "Crete Round",
                    "Crimson Pro",
                    "Crimson Text",
                    "Croissant One",
                    "Crushed",
                    "Cuprum",
                    "Cute Font",
                    "Cutive",
                    "Cutive Mono",
                    "DM Mono",
                    "DM Sans",
                    "DM Serif Display",
                    "DM Serif Text",
                    "Damion",
                    "Dancing Script",
                    "Dangrek",
                    "Darker Grotesque",
                    "David Libre",
                    "Dawning of a New Day",
                    "Days One",
                    "Dekko",
                    "Dela Gothic One",
                    "Delius",
                    "Delius Swash Caps",
                    "Delius Unicase",
                    "Della Respira",
                    "Denk One",
                    "Devonshire",
                    "Dhurjati",
                    "Didact Gothic",
                    "Diplomata",
                    "Diplomata SC",
                    "Do Hyeon",
                    "Dokdo",
                    "Domine",
                    "Donegal One",
                    "Doppio One",
                    "Dorsa",
                    "Dosis",
                    "DotGothic16",
                    "Dr Sugiyama",
                    "Duru Sans",
                    "Dynalight",
                    "EB Garamond",
                    "Eagle Lake",
                    "East Sea Dokdo",
                    "Eater",
                    "Economica",
                    "Eczar",
                    "El Messiri",
                    "Electrolize",
                    "Elsie",
                    "Elsie Swash Caps",
                    "Emblema One",
                    "Emilys Candy",
                    "Encode Sans",
                    "Encode Sans Condensed",
                    "Encode Sans Expanded",
                    "Encode Sans Semi Condensed",
                    "Encode Sans Semi Expanded",
                    "Engagement",
                    "Englebert",
                    "Enriqueta",
                    "Epilogue",
                    "Erica One",
                    "Esteban",
                    "Euphoria Script",
                    "Ewert",
                    "Exo",
                    "Exo 2",
                    "Expletus Sans",
                    "Fahkwang",
                    "Fanwood Text",
                    "Farro",
                    "Farsan",
                    "Fascinate",
                    "Fascinate Inline",
                    "Faster One",
                    "Fasthand",
                    "Fauna One",
                    "Faustina",
                    "Federant",
                    "Federo",
                    "Felipa",
                    "Fenix",
                    "Finger Paint",
                    "Fira Code",
                    "Fira Mono",
                    "Fira Sans",
                    "Fira Sans Condensed",
                    "Fira Sans Extra Condensed",
                    "Fjalla One",
                    "Fjord One",
                    "Flamenco",
                    "Flavors",
                    "Fondamento",
                    "Fontdiner Swanky",
                    "Forum",
                    "Francois One",
                    "Frank Ruhl Libre",
                    "Fraunces",
                    "Freckle Face",
                    "Fredericka the Great",
                    "Fredoka One",
                    "Freehand",
                    "Fresca",
                    "Frijole",
                    "Fruktur",
                    "Fugaz One",
                    "GFS Didot",
                    "GFS Neohellenic",
                    "Gabriela",
                    "Gaegu",
                    "Gafata",
                    "Galada",
                    "Galdeano",
                    "Galindo",
                    "Gamja Flower",
                    "Gayathri",
                    "Gelasio",
                    "Gentium Basic",
                    "Gentium Book Basic",
                    "Geo",
                    "Geostar",
                    "Geostar Fill",
                    "Germania One",
                    "Gidugu",
                    "Gilda Display",
                    "Girassol",
                    "Give You Glory",
                    "Glass Antiqua",
                    "Glegoo",
                    "Gloria Hallelujah",
                    "Goblin One",
                    "Gochi Hand",
                    "Goldman",
                    "Gorditas",
                    "Gothic A1",
                    "Gotu",
                    "Goudy Bookletter 1911",
                    "Graduate",
                    "Grand Hotel",
                    "Grandstander",
                    "Gravitas One",
                    "Great Vibes",
                    "Grenze",
                    "Grenze Gotisch",
                    "Griffy",
                    "Gruppo",
                    "Gudea",
                    "Gugi",
                    "Gupter",
                    "Gurajada",
                    "Habibi",
                    "Hachi Maru Pop",
                    "Halant",
                    "Hammersmith One",
                    "Hanalei",
                    "Hanalei Fill",
                    "Handlee",
                    "Hanuman",
                    "Happy Monkey",
                    "Harmattan",
                    "Headland One",
                    "Heebo",
                    "Henny Penny",
                    "Hepta Slab",
                    "Herr Von Muellerhoff",
                    "Hi Melody",
                    "Hind",
                    "Hind Guntur",
                    "Hind Madurai",
                    "Hind Siliguri",
                    "Hind Vadodara",
                    "Holtwood One SC",
                    "Homemade Apple",
                    "Homenaje",
                    "IBM Plex Mono",
                    "IBM Plex Sans",
                    "IBM Plex Sans Condensed",
                    "IBM Plex Serif",
                    "IM Fell DW Pica",
                    "IM Fell DW Pica SC",
                    "IM Fell Double Pica",
                    "IM Fell Double Pica SC",
                    "IM Fell English",
                    "IM Fell English SC",
                    "IM Fell French Canon",
                    "IM Fell French Canon SC",
                    "IM Fell Great Primer",
                    "IM Fell Great Primer SC",
                    "Ibarra Real Nova",
                    "Iceberg",
                    "Iceland",
                    "Imbue",
                    "Imprima",
                    "Inconsolata",
                    "Inder",
                    "Indie Flower",
                    "Inika",
                    "Inknut Antiqua",
                    "Inria Sans",
                    "Inria Serif",
                    "Inter",
                    "Irish Grover",
                    "Istok Web",
                    "Italiana",
                    "Italianno",
                    "Itim",
                    "Jacques Francois",
                    "Jacques Francois Shadow",
                    "Jaldi",
                    "JetBrains Mono",
                    "Jim Nightshade",
                    "Jockey One",
                    "Jolly Lodger",
                    "Jomhuria",
                    "Jomolhari",
                    "Josefin Sans",
                    "Josefin Slab",
                    "Jost",
                    "Joti One",
                    "Jua",
                    "Judson",
                    "Julee",
                    "Julius Sans One",
                    "Junge",
                    "Jura",
                    "Just Another Hand",
                    "Just Me Again Down Here",
                    "K2D",
                    "Kadwa",
                    "Kalam",
                    "Kameron",
                    "Kanit",
                    "Kantumruy",
                    "Karantina",
                    "Karla",
                    "Karma",
                    "Katibeh",
                    "Kaushan Script",
                    "Kavivanar",
                    "Kavoon",
                    "Kdam Thmor",
                    "Keania One",
                    "Kelly Slab",
                    "Kenia",
                    "Khand",
                    "Khmer",
                    "Khula",
                    "Kirang Haerang",
                    "Kite One",
                    "Kiwi Maru",
                    "Knewave",
                    "KoHo",
                    "Kodchasan",
                    "Kosugi",
                    "Kosugi Maru",
                    "Kotta One",
                    "Koulen",
                    "Kranky",
                    "Kreon",
                    "Kristi",
                    "Krona One",
                    "Krub",
                    "Kufam",
                    "Kulim Park",
                    "Kumar One",
                    "Kumar One Outline",
                    "Kumbh Sans",
                    "Kurale",
                    "La Belle Aurore",
                    "Lacquer",
                    "Laila",
                    "Lakki Reddy",
                    "Lalezar",
                    "Lancelot",
                    "Langar",
                    "Lateef",
                    "Lato",
                    "League Script",
                    "Leckerli One",
                    "Ledger",
                    "Lekton",
                    "Lemon",
                    "Lemonada",
                    "Lexend",
                    "Lexend Deca",
                    "Lexend Exa",
                    "Lexend Giga",
                    "Lexend Mega",
                    "Lexend Peta",
                    "Lexend Tera",
                    "Lexend Zetta",
                    "Libre Barcode 128",
                    "Libre Barcode 128 Text",
                    "Libre Barcode 39",
                    "Libre Barcode 39 Extended",
                    "Libre Barcode 39 Extended Text",
                    "Libre Barcode 39 Text",
                    "Libre Barcode EAN13 Text",
                    "Libre Baskerville",
                    "Libre Caslon Display",
                    "Libre Caslon Text",
                    "Libre Franklin",
                    "Life Savers",
                    "Lilita One",
                    "Lily Script One",
                    "Limelight",
                    "Linden Hill",
                    "Literata",
                    "Liu Jian Mao Cao",
                    "Livvic",
                    "Lobster",
                    "Lobster Two",
                    "Londrina Outline",
                    "Londrina Shadow",
                    "Londrina Sketch",
                    "Londrina Solid",
                    "Long Cang",
                    "Lora",
                    "Love Ya Like A Sister",
                    "Loved by the King",
                    "Lovers Quarrel",
                    "Luckiest Guy",
                    "Lusitana",
                    "Lustria",
                    "M PLUS 1p",
                    "M PLUS Rounded 1c",
                    "Ma Shan Zheng",
                    "Macondo",
                    "Macondo Swash Caps",
                    "Mada",
                    "Magra",
                    "Maiden Orange",
                    "Maitree",
                    "Major Mono Display",
                    "Mako",
                    "Mali",
                    "Mallanna",
                    "Mandali",
                    "Manjari",
                    "Manrope",
                    "Mansalva",
                    "Manuale",
                    "Marcellus",
                    "Marcellus SC",
                    "Marck Script",
                    "Margarine",
                    "Markazi Text",
                    "Marko One",
                    "Marmelad",
                    "Martel",
                    "Martel Sans",
                    "Marvel",
                    "Mate",
                    "Mate SC",
                    "Maven Pro",
                    "McLaren",
                    "Meddon",
                    "MedievalSharp",
                    "Medula One",
                    "Meera Inimai",
                    "Megrim",
                    "Meie Script",
                    "Merienda",
                    "Merienda One",
                    "Merriweather",
                    "Merriweather Sans",
                    "Metal",
                    "Metal Mania",
                    "Metamorphous",
                    "Metrophobic",
                    "Michroma",
                    "Milonga",
                    "Miltonian",
                    "Miltonian Tattoo",
                    "Mina",
                    "Miniver",
                    "Miriam Libre",
                    "Mirza",
                    "Miss Fajardose",
                    "Mitr",
                    "Modak",
                    "Modern Antiqua",
                    "Mogra",
                    "Molengo",
                    "Molle",
                    "Monda",
                    "Monofett",
                    "Monoton",
                    "Monsieur La Doulaise",
                    "Montaga",
                    "Montez",
                    "Montserrat",
                    "Montserrat Alternates",
                    "Montserrat Subrayada",
                    "Moul",
                    "Moulpali",
                    "Mountains of Christmas",
                    "Mouse Memoirs",
                    "Mr Bedfort",
                    "Mr Dafoe",
                    "Mr De Haviland",
                    "Mrs Saint Delafield",
                    "Mrs Sheppards",
                    "Mukta",
                    "Mukta Mahee",
                    "Mukta Malar",
                    "Mukta Vaani",
                    "Mulish",
                    "MuseoModerno",
                    "Mystery Quest",
                    "NTR",
                    "Nanum Brush Script",
                    "Nanum Gothic",
                    "Nanum Gothic Coding",
                    "Nanum Myeongjo",
                    "Nanum Pen Script",
                    "Nerko One",
                    "Neucha",
                    "Neuton",
                    "New Rocker",
                    "New Tegomin",
                    "News Cycle",
                    "Newsreader",
                    "Niconne",
                    "Niramit",
                    "Nixie One",
                    "Nobile",
                    "Nokora",
                    "Norican",
                    "Nosifer",
                    "Notable",
                    "Nothing You Could Do",
                    "Noticia Text",
                    "Noto Sans",
                    "Noto Sans HK",
                    "Noto Sans JP",
                    "Noto Sans KR",
                    "Noto Sans SC",
                    "Noto Sans TC",
                    "Noto Serif",
                    "Noto Serif JP",
                    "Noto Serif KR",
                    "Noto Serif SC",
                    "Noto Serif TC",
                    "Nova Cut",
                    "Nova Flat",
                    "Nova Mono",
                    "Nova Oval",
                    "Nova Round",
                    "Nova Script",
                    "Nova Slim",
                    "Nova Square",
                    "Numans",
                    "Nunito",
                    "Nunito Sans",
                    "Odibee Sans",
                    "Odor Mean Chey",
                    "Offside",
                    "Oi",
                    "Old Standard TT",
                    "Oldenburg",
                    "Oleo Script",
                    "Oleo Script Swash Caps",
                    "Open Sans",
                    "Open Sans Condensed",
                    "Oranienbaum",
                    "Orbitron",
                    "Oregano",
                    "Orelega One",
                    "Orienta",
                    "Original Surfer",
                    "Oswald",
                    "Over the Rainbow",
                    "Overlock",
                    "Overlock SC",
                    "Overpass",
                    "Overpass Mono",
                    "Ovo",
                    "Oxanium",
                    "Oxygen",
                    "Oxygen Mono",
                    "PT Mono",
                    "PT Sans",
                    "PT Sans Caption",
                    "PT Sans Narrow",
                    "PT Serif",
                    "PT Serif Caption",
                    "Pacifico",
                    "Padauk",
                    "Palanquin",
                    "Palanquin Dark",
                    "Pangolin",
                    "Paprika",
                    "Parisienne",
                    "Passero One",
                    "Passion One",
                    "Pathway Gothic One",
                    "Patrick Hand",
                    "Patrick Hand SC",
                    "Pattaya",
                    "Patua One",
                    "Pavanam",
                    "Paytone One",
                    "Peddana",
                    "Peralta",
                    "Permanent Marker",
                    "Petit Formal Script",
                    "Petrona",
                    "Philosopher",
                    "Piazzolla",
                    "Piedra",
                    "Pinyon Script",
                    "Pirata One",
                    "Plaster",
                    "Play",
                    "Playball",
                    "Playfair Display",
                    "Playfair Display SC",
                    "Podkova",
                    "Poiret One",
                    "Poller One",
                    "Poly",
                    "Pompiere",
                    "Pontano Sans",
                    "Poor Story",
                    "Poppins",
                    "Port Lligat Sans",
                    "Port Lligat Slab",
                    "Potta One",
                    "Pragati Narrow",
                    "Prata",
                    "Preahvihear",
                    "Press Start 2P",
                    "Pridi",
                    "Princess Sofia",
                    "Prociono",
                    "Prompt",
                    "Prosto One",
                    "Proza Libre",
                    "Public Sans",
                    "Puritan",
                    "Purple Purse",
                    "Quando",
                    "Quantico",
                    "Quattrocento",
                    "Quattrocento Sans",
                    "Questrial",
                    "Quicksand",
                    "Quintessential",
                    "Qwigley",
                    "Racing Sans One",
                    "Radley",
                    "Rajdhani",
                    "Rakkas",
                    "Raleway",
                    "Raleway Dots",
                    "Ramabhadra",
                    "Ramaraja",
                    "Rambla",
                    "Rammetto One",
                    "Ranchers",
                    "Rancho",
                    "Ranga",
                    "Rasa",
                    "Rationale",
                    "Ravi Prakash",
                    "Recursive",
                    "Red Hat Display",
                    "Red Hat Text",
                    "Red Rose",
                    "Redressed",
                    "Reem Kufi",
                    "Reenie Beanie",
                    "Reggae One",
                    "Revalia",
                    "Rhodium Libre",
                    "Ribeye",
                    "Ribeye Marrow",
                    "Righteous",
                    "Risque",
                    "Roboto",
                    "Roboto Condensed",
                    "Roboto Mono",
                    "Roboto Slab",
                    "Rochester",
                    "Rock Salt",
                    "RocknRoll One",
                    "Rokkitt",
                    "Romanesco",
                    "Ropa Sans",
                    "Rosario",
                    "Rosarivo",
                    "Rouge Script",
                    "Rowdies",
                    "Rozha One",
                    "Rubik",
                    "Rubik Mono One",
                    "Ruda",
                    "Rufina",
                    "Ruge Boogie",
                    "Ruluko",
                    "Rum Raisin",
                    "Ruslan Display",
                    "Russo One",
                    "Ruthie",
                    "Rye",
                    "Sacramento",
                    "Sahitya",
                    "Sail",
                    "Saira",
                    "Saira Condensed",
                    "Saira Extra Condensed",
                    "Saira Semi Condensed",
                    "Saira Stencil One",
                    "Salsa",
                    "Sanchez",
                    "Sancreek",
                    "Sansita",
                    "Sansita Swashed",
                    "Sarabun",
                    "Sarala",
                    "Sarina",
                    "Sarpanch",
                    "Satisfy",
                    "Sawarabi Gothic",
                    "Sawarabi Mincho",
                    "Scada",
                    "Scheherazade",
                    "Schoolbell",
                    "Scope One",
                    "Seaweed Script",
                    "Secular One",
                    "Sedgwick Ave",
                    "Sedgwick Ave Display",
                    "Sen",
                    "Sevillana",
                    "Seymour One",
                    "Shadows Into Light",
                    "Shadows Into Light Two",
                    "Shanti",
                    "Share",
                    "Share Tech",
                    "Share Tech Mono",
                    "Shippori Mincho",
                    "Shippori Mincho B1",
                    "Shojumaru",
                    "Short Stack",
                    "Shrikhand",
                    "Siemreap",
                    "Sigmar One",
                    "Signika",
                    "Signika Negative",
                    "Simonetta",
                    "Single Day",
                    "Sintony",
                    "Sirin Stencil",
                    "Six Caps",
                    "Skranji",
                    "Slabo 13px",
                    "Slabo 27px",
                    "Slackey",
                    "Smokum",
                    "Smythe",
                    "Sniglet",
                    "Snippet",
                    "Snowburst One",
                    "Sofadi One",
                    "Sofia",
                    "Solway",
                    "Song Myung",
                    "Sonsie One",
                    "Sora",
                    "Sorts Mill Goudy",
                    "Source Code Pro",
                    "Source Sans Pro",
                    "Source Serif Pro",
                    "Space Grotesk",
                    "Space Mono",
                    "Spartan",
                    "Special Elite",
                    "Spectral",
                    "Spectral SC",
                    "Spicy Rice",
                    "Spinnaker",
                    "Spirax",
                    "Squada One",
                    "Sree Krushnadevaraya",
                    "Sriracha",
                    "Srisakdi",
                    "Staatliches",
                    "Stalemate",
                    "Stalinist One",
                    "Stardos Stencil",
                    "Stick",
                    "Stint Ultra Condensed",
                    "Stint Ultra Expanded",
                    "Stoke",
                    "Strait",
                    "Stylish",
                    "Sue Ellen Francisco",
                    "Suez One",
                    "Sulphur Point",
                    "Sumana",
                    "Sunflower",
                    "Sunshiney",
                    "Supermercado One",
                    "Sura",
                    "Suranna",
                    "Suravaram",
                    "Suwannaphum",
                    "Swanky and Moo Moo",
                    "Syncopate",
                    "Syne",
                    "Syne Mono",
                    "Syne Tactile",
                    "Tajawal",
                    "Tangerine",
                    "Taprom",
                    "Tauri",
                    "Taviraj",
                    "Teko",
                    "Telex",
                    "Tenali Ramakrishna",
                    "Tenor Sans",
                    "Text Me One",
                    "Texturina",
                    "Thasadith",
                    "The Girl Next Door",
                    "Tienne",
                    "Tillana",
                    "Timmana",
                    "Tinos",
                    "Titan One",
                    "Titillium Web",
                    "Tomorrow",
                    "Trade Winds",
                    "Train One",
                    "Trirong",
                    "Trispace",
                    "Trocchi",
                    "Trochut",
                    "Truculenta",
                    "Trykker",
                    "Tulpen One",
                    "Turret Road",
                    "Ubuntu",
                    "Ubuntu Condensed",
                    "Ubuntu Mono",
                    "Ultra",
                    "Uncial Antiqua",
                    "Underdog",
                    "Unica One",
                    "UnifrakturCook",
                    "UnifrakturMaguntia",
                    "Unkempt",
                    "Unlock",
                    "Unna",
                    "VT323",
                    "Vampiro One",
                    "Varela",
                    "Varela Round",
                    "Varta",
                    "Vast Shadow",
                    "Vesper Libre",
                    "Viaoda Libre",
                    "Vibes",
                    "Vibur",
                    "Vidaloka",
                    "Viga",
                    "Voces",
                    "Volkhov",
                    "Vollkorn",
                    "Vollkorn SC",
                    "Voltaire",
                    "Waiting for the Sunrise",
                    "Wallpoet",
                    "Walter Turncoat",
                    "Warnes",
                    "Wellfleet",
                    "Wendy One",
                    "Wire One",
                    "Work Sans",
                    "Xanh Mono",
                    "Yantramanav",
                    "Yatra One",
                    "Yellowtail",
                    "Yeon Sung",
                    "Yeseva One",
                    "Yesteryear",
                    "Yrsa",
                    "Yusei Magic",
                    "ZCOOL KuaiLe",
                    "ZCOOL QingKe HuangYou",
                    "ZCOOL XiaoWei",
                    "Zen Dots",
                    "Zeyada",
                    "Zhi Mang Xing",
                    "Zilla Slab",
                    "Zilla Slab Highlight"
                ],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:46.9666667Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1326238Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"Image Free Layout - Gold\"",
                "optionsJson": "{\"options\":[\"Main Layout\",\"Image Free Layout\"]}",
                "key": "GRAZE_LAYOUT",
                "settingAreaId": 1,
                "name": "Graze layout",
                "description": "",
                "valueType": "Custom",
                "audience": "General",
                "value": "Image Free Layout - Gold",
                "options": [
                    "Main Layout",
                    "Image Free Layout"
                ],
                "recordStatus": "Active",
                "createdUtcDateTime": "2023-04-18T14:02:45.53Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1432354Z",
                "createdBy": "DB Script",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"We are closed!!~!!!\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ONLINE_ORDERS_CLOSED_MESSAGE",
                "settingAreaId": 1,
                "name": "Online Order Closed Message",
                "description": "This message will be displayed on the online ordering page if orders are submitted during \"off hours\" (outside of \"open hours\", during order holidays or while online orders are \"paused\").",
                "valueType": "String",
                "audience": "General",
                "value": "We are closed!!~!!!",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:46.65Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1514611Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"According Open Hours\"",
                "optionsJson": "{\"options\":[\"According Open Hours\",\"Online Orders Paused\"]}",
                "key": "GRAZE_ONLINE_ORDERS_ENABLED",
                "settingAreaId": 1,
                "name": "Online Order Enabled",
                "description": "Choose to manually pause online orders or to allow them according to your \"Open Hours\" scheduled (below).",
                "valueType": "Switch",
                "audience": "General",
                "value": "According Open Hours",
                "options": [
                    "According Open Hours",
                    "Online Orders Paused"
                ],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:46.6533333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1590104Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "[]",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ONLINE_ORDERS_HOLIDAYS",
                "settingAreaId": 1,
                "name": "Online Order Holidays",
                "description": "Online orders cannot be scheduled on these dates and ASAP orders will avoid these dates.",
                "valueType": "Custom",
                "audience": "General",
                "value": [],
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:47.4433333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1667986Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "[[\"6:00 AM\",\"11:59 PM\",true,true,true,true,true,true,true]]",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_OPEN_HOURS",
                "settingAreaId": 1,
                "name": "Online Order Open Hours",
                "description": "Online orders can only be scheduled during these days and times and ASAP orders will automatically honor them, as well. (If no days and times are specified, orders will be accepted 24/7; if no \"Open Time\" is specified, orders will be accepted as early as 12:00AM on those days; if no \"Close Time\" is specified, orders will be accepted until 11:59PM on those days.)",
                "valueType": "Custom",
                "audience": "General",
                "value": [
                    [
                        "6:00 AM",
                        "11:59 PM",
                        true,
                        true,
                        true,
                        true,
                        true,
                        true,
                        true
                    ]
                ],
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:46.65Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1807836Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"48\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_ADVANCED_NOTICE",
                "settingAreaId": 1,
                "name": "Orders Advanced Notice (hours)",
                "description": "Orders cannot be placed if times do not allow at least as much advance notice as listed here.",
                "valueType": "Integer",
                "audience": "General",
                "value": "48",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-12-30T17:43:20.8433333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1895751Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"If you need to change or cancel your order, please call the restaurant.\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_CANCELLATION_POLICY",
                "settingAreaId": 1,
                "name": "Online Order Cancellation Policy",
                "description": "Text will be displayed at the bottom of the online order confirmation page.",
                "valueType": "Multiline",
                "audience": "General",
                "value": "If you need to change or cancel your order, please call the restaurant.",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2023-02-20T16:09:31.2333333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.1980851Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"We have emailed your order confirmation, and will send you an update when your order is ready.\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_CONFIRMATION_CUSTOM_MESSAGE",
                "settingAreaId": 1,
                "name": "Order Confirmation Custom Message",
                "description": "Text will be displayed at the top of the online order confirmation page.",
                "valueType": "Multiline",
                "audience": "General",
                "value": "We have emailed your order confirmation, and will send you an update when your order is ready.",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2022-12-13T18:40:04.2033333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.2066655Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"0\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_MINIMUM",
                "settingAreaId": 1,
                "name": "Order Minimum",
                "description": "Orders cannot be submitted if the order total (subtotal + service charge + tax) falls below this amount.",
                "valueType": "Integer",
                "audience": "General",
                "value": "0",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:46.31Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.2159588Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"Order minimum of {orderMinimum} is not met.\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_MINIMUM_MESSAGE",
                "settingAreaId": 1,
                "name": "Order Minimum Message",
                "description": "This message will be displayed if an order falls below the \"Order Minimum\" above. (To reference the specific minimum amount in your message, use {orderMinimum}.)",
                "valueType": "String",
                "audience": "General",
                "value": "Order minimum of {orderMinimum} is not met.",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:46.31Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.2240053Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"By providing your phone number, you consent to receive text messages from our company related to your order. Standard message rates may apply.\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_TERMS_CUSTOM_MESSAGE",
                "settingAreaId": 1,
                "name": "Order Terms Custom Message",
                "description": "Text will be displayed at the bottom of the order page.",
                "valueType": "Multiline",
                "audience": "General",
                "value": "By providing your phone number, you consent to receive text messages from our company related to your order. Standard message rates may apply.",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2022-12-13T18:40:04.2033333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.2317406Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "[]",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_THROTTLING",
                "settingAreaId": 1,
                "name": "Online Order Throttling",
                "description": "Online order times will be buffered or orders will be paused entirely based on the rules set here. (If no \"Start Time\" is specified, throttling rules will begin at 12:00AM on those days; if no \"End Time\" is specified, throttling rules will expire at 11:59PM on those days.)",
                "valueType": "Custom",
                "audience": "General",
                "value": [],
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:48.4533333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.2398704Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"Our kitchen is overwhelmed ....\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_THROTTLING_MESSAGE",
                "settingAreaId": 1,
                "name": "Online Order Overload Message",
                "description": "The online order checkout page will display this message if any of the above throttling settings is reached.",
                "valueType": "String",
                "audience": "General",
                "value": "Our kitchen is overwhelmed ....",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:48.4533333Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.2478511Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "{\"enabledOrderType\":{\"pickup\":true,\"delivery\":true,\"event\":true},\"defaultOrderType\":\"pickup\",\"preserveUserChoice\":false}",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_TYPE",
                "settingAreaId": 1,
                "name": "Order Type",
                "description": "Choose to have online order type default to \"Pickup\", \"Delivery\" or \"Event\" always, or default the first time and then preserve the user`s selection after that.",
                "valueType": "Custom",
                "audience": "General",
                "value": {
                    "enabledOrderType": {
                        "pickup": true,
                        "delivery": true,
                        "event": true
                    },
                    "defaultOrderType": "pickup",
                    "preserveUserChoice": false
                },
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2023-03-13T17:24:56.75Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.2565865Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"We can not deliver to this address at this time. Please choose other options.\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_ORDER_UNDELIVERABLE_ZONE",
                "settingAreaId": 1,
                "name": "Order Undeliverable Zone Message",
                "description": "The online order checkout page will display this message if the delivery address of an order falls into a zone designated as \"undeliverable\". (See Company Settings > Financials > Delivery Zones.)",
                "valueType": "String",
                "audience": "General",
                "value": "We can not deliver to this address at this time. Please choose other options.",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-07-03T01:53:47.86Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.2650768Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"https://horizoncoverdevsa.blob.core.windows.net/public/2a73da9d-3163-4eeb-cda8-08d77746ce6e/companyLogo/-1/bab00da0-fd61-4de6-8ad4-0cd33c479554.png\"",
                "optionsJson": "{\"options\":[]}",
                "key": "GRAZE_WEBSITE_ICON",
                "settingAreaId": 1,
                "name": "Website Icon",
                "description": "Upload a small 16×16 pixel icon that serves as branding for your website in Graze. (Transparent background recommended.)",
                "valueType": "Custom",
                "audience": "General",
                "value": "https://horizoncoverdevsa.blob.core.windows.net/public/2a73da9d-3163-4eeb-cda8-08d77746ce6e/companyLogo/-1/bab00da0-fd61-4de6-8ad4-0cd33c479554.png",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2022-12-07T15:59:05.36Z",
                "lastModifiedUtcDateTime": "2023-09-12T19:24:26.2734632Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "a93819df-68c3-42bd-b5f2-f65a6742a4e5",
                "typeName": "Setting"
            }
        ],
        "recordStatus": "Active",
        "createdUtcDateTime": "2021-02-02T19:12:20.3266667Z",
        "lastModifiedUtcDateTime": null,
        "createdBy": "DB Script",
        "lastModifiedBy": null,
        "typeName": "SettingArea"
    },
    {
        "id": 2,
        "name": "Account",
        "description": null,
        "settings": [
            {
                "valueJson": "[\"#5b89d2\",\"#332f32\",\"#b54023\",\"#e8b712\"]",
                "optionsJson": "{\"options\":[]}",
                "key": "ACCOUNT_COLOR_SCHEME",
                "settingAreaId": 2,
                "name": "Color Scheme",
                "description": "Determine random colors to be assigned to menu categories at the top of your online ordering portal.",
                "valueType": "Custom",
                "audience": "General",
                "value": [
                    "#5b89d2",
                    "#332f32",
                    "#b54023",
                    "#e8b712"
                ],
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-02-02T19:12:20.3433333Z",
                "lastModifiedUtcDateTime": "2022-09-07T18:25:31.4638904Z",
                "createdBy": "DB Script",
                "lastModifiedBy": "Chris Kopriva",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"https://horizoncoverstagingsa.blob.core.windows.net/public/2a73da9d-3163-4eeb-cda8-08d77746ce6e%2FcompanyLogo%2F-1%2F24cee079-9842-4d6f-94f8-f5a71818cbd7.png\"",
                "optionsJson": "{\"options\":[]}",
                "key": "COVER_COMPANY_LOGO",
                "settingAreaId": 2,
                "name": "Company Logo",
                "description": "Upload logo for display in the top left corner of this back-office program. Note: Aspect ratio is locked for standard web app placeholder. Use transparent image for best results.",
                "valueType": "Custom",
                "audience": "General",
                "value": "https://horizoncoverstagingsa.blob.core.windows.net/public/2a73da9d-3163-4eeb-cda8-08d77746ce6e%2FcompanyLogo%2F-1%2F24cee079-9842-4d6f-94f8-f5a71818cbd7.png",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-12-28T04:57:06.2733333Z",
                "lastModifiedUtcDateTime": "2022-09-07T18:25:31.4736571Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "Chris Kopriva",
                "typeName": "Setting"
            },
            {
                "valueJson": "\"https://horizoncoverstagingsa.blob.core.windows.net/public/2a73da9d-3163-4eeb-cda8-08d77746ce6e%2FcompanyLogo%2F-1%2F6a0a8d1d-1521-46d2-96f6-45b495f3ffd5.png\"",
                "optionsJson": "{\"options\":[]}",
                "key": "REPORT_COMPANY_LOGO",
                "settingAreaId": 2,
                "name": "Print Logo",
                "description": "Upload logo for display on program prints.  Note: Aspect ratios vary on different prints; check print previews and use transparent image for best results.",
                "valueType": "Custom",
                "audience": "General",
                "value": "https://horizoncoverstagingsa.blob.core.windows.net/public/2a73da9d-3163-4eeb-cda8-08d77746ce6e%2FcompanyLogo%2F-1%2F6a0a8d1d-1521-46d2-96f6-45b495f3ffd5.png",
                "options": [],
                "recordStatus": "Active",
                "createdUtcDateTime": "2021-12-28T04:57:06.2733333Z",
                "lastModifiedUtcDateTime": "2022-09-07T18:25:31.4785407Z",
                "createdBy": "DB Sript",
                "lastModifiedBy": "Chris Kopriva",
                "typeName": "Setting"
            }
        ],
        "recordStatus": "Active",
        "createdUtcDateTime": "2021-02-02T19:12:20.34Z",
        "lastModifiedUtcDateTime": null,
        "createdBy": "DB Script",
        "lastModifiedBy": null,
        "typeName": "SettingArea"
    }
]